import React from 'react'
import useCallApi from './CallApi'

const Welcome = ({ setView }) => {
  const orders = useCallApi('https://ezer-eventapp.onrender.com/orders')
  const enquiries = useCallApi('https://ezer-eventapp.onrender.com/enquiries')

  return (
    <div className='container text-center'>
      <h1>Welcome to Admin Dashboard</h1>
      <div className='row'>
        <div className='col-lg-6 p-5'>
          <div className='card' onClick={() => setView("ViewOrders")} style={{cursor:"pointer"}}>
            <div className='card-body text-center'>
              <h3>Total Orders</h3>
              <h1 className='text-bg-success p-3'>{orders.length}</h1>
            </div>
          </div>
        </div>
        <div className='col-lg-6 p-5'>
          <div className='card' onClick={() => setView("ViewEnquiry")} style={{cursor:"pointer"}}>
            <div className='card-body text-center'>
              <h3>Total Enquiries</h3>
              <h1 className='text-bg-success p-3'>{enquiries.length}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome
